import React from 'react';

// Opciones de ITBIS según DGII (IndicadorFacturacion)
const OPCIONES_ITBIS = [
  { value: 1, label: "Gravado 18%", tasa: 18 },
  { value: 2, label: "Gravado 16%", tasa: 16 },
  { value: 3, label: "Gravado 0%", tasa: 0 },
  { value: 4, label: "Exento", tasa: 0 }
];

/**
 * Select simple para indicador de facturación ITBIS
 * Alineado con estructura e-CF de DGII
 * 
 * @param {number} value - Valor actual (1-4)
 * @param {function} onChange - Callback con { indicador_facturacion, itbis_tasa }
 * @param {boolean} disabled - Si está deshabilitado
 * @param {string} className - Clases adicionales
 */
const SelectIndicadorITBIS = ({
  value = 1,
  onChange,
  disabled = false,
  className = ''
}) => {
  
  const handleChange = (e) => {
    const indicador = parseInt(e.target.value);
    const opcion = OPCIONES_ITBIS.find(op => op.value === indicador);
    
    onChange({
      indicador_facturacion: indicador,
      itbis_tasa: opcion?.tasa || 0
    });
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white 
        ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-100' : 'hover:border-gray-400'} 
        ${className}`}
    >
      {OPCIONES_ITBIS.map(opcion => (
        <option key={opcion.value} value={opcion.value}>
          {opcion.label}
        </option>
      ))}
    </select>
  );
};

// Exportar también las opciones para uso externo
export { OPCIONES_ITBIS };
export default SelectIndicadorITBIS;









